// utils.ts
import { languageOptions } from '@/_utils/Constants'

export const getFilteredLanguages = (websiteLanguages: any[]) => {
  return languageOptions
    .filter((option) =>
      websiteLanguages.some((lang) => lang.value === option.value)
    )
    .sort(
      (a, b) =>
        websiteLanguages.findIndex((lang) => lang.value === a.value) -
        websiteLanguages.findIndex((lang) => lang.value === b.value)
    )
}

export const getActiveLanguage = (currentLocale: string) => {
  return languageOptions.find((el) => el.value === currentLocale)
}
